import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PageMeta from "@/components/PageMeta";
import HomePage from "@/pages/HomePage";
import NewLandingPage from "@/pages/NewLandingPage";
import PremiumHomeHero from "@/components/premium/PremiumHomeHero";
import PremiumDashboard from "@/pages/premium/PremiumDashboard";
import PremiumWorkspace from "@/pages/premium/PremiumWorkspace";
import PremiumAIStudio from "@/pages/premium/PremiumAIStudio";
import PremiumTeachingSuite from "@/pages/premium/PremiumTeachingSuite";
import PremiumYouTubeSuite from "@/pages/premium/PremiumYouTubeSuite";
import PremiumContentSuite from "@/pages/premium/PremiumContentSuite";
import PremiumReports from "@/pages/premium/PremiumReports";
import PremiumChannelAssessment from "@/pages/premium/PremiumChannelAssessment";
import TeachingTool from "@/pages/teaching/TeachingTool";
import TeachingTemplate from "@/pages/teaching/TeachingTemplate";
import PPTToQuiz from "@/pages/teaching/PPTToQuiz";
import TeachingAIAssistant from "@/pages/teaching/TeachingAIAssistant";
import { BundlesList, BundleView, PublicBundleView } from "@/pages/teaching/TeachingBundles";
import SuiteTool from "@/pages/suite/SuiteTool";
import GlobalCommandPalette from "@/components/premium/GlobalCommandPalette";
import ForAgenciesPage from "@/pages/ForAgenciesPage";
import WorkflowsHub from "@/pages/workflows/WorkflowsHub";
import WorkflowStart from "@/pages/workflows/WorkflowStart";
import WorkflowProject from "@/pages/workflows/WorkflowProject";
import PPTGeneratorPage from "@/pages/tools/PPTGeneratorPage";
import SRTGeneratorPage from "@/pages/tools/SRTGeneratorPage";
import ThumbnailStudioPage from "@/pages/tools/ThumbnailStudioPage";
import SarvamStudioPage from "@/pages/tools/SarvamStudioPage";
import LiveCaptionsPage from "@/pages/tools/LiveCaptionsPage";
import KimiBoosterPage from "@/pages/tools/KimiBoosterPage";
import RegionalToolkitPage from "@/pages/tools/RegionalToolkitPage";
import ScaleToolkitPage from "@/pages/tools/ScaleToolkitPage";
import CreatorIncentivePage from "@/pages/CreatorIncentivePage";
import AutoCaptionsPage from "@/pages/tools/AutoCaptionsPage";
import AutoCaptionsHistoryPage from "@/pages/tools/AutoCaptionsHistoryPage";
import AutoCaptionsSharePage from "@/pages/tools/AutoCaptionsSharePage";
import AutoCaptionsBrandKitPage from "@/pages/tools/AutoCaptionsBrandKitPage";
import StudioHub from "@/pages/studio/StudioHub";
import StudioChannel from "@/pages/studio/StudioChannel";
import StudioMyTasks from "@/pages/studio/StudioMyTasks";
import StudioCalendar from "@/pages/studio/StudioCalendar";
import StudioSearch from "@/pages/studio/StudioSearch";
import StudioScorecard from "@/pages/studio/StudioScorecard";
import StudioTrash from "@/pages/studio/StudioTrash";
import StudioApprovals from "@/pages/studio/StudioApprovals";
import StudioSponsorships from "@/pages/studio/StudioSponsorships";
import StudioSettings from "@/pages/studio/StudioSettings";
import StudioWorkload from "@/pages/studio/StudioWorkload";
import StudioTopicSuggestions from "@/pages/studio/StudioTopicSuggestions";
import StudioReports from "@/pages/studio/StudioReports";
import StudioRoleDashboard from "@/pages/studio/StudioRoleDashboard";
import StudioBilling from "@/pages/studio/StudioBilling";
import StudioPublicShare from "@/pages/studio/StudioPublicShare";
import StudioCommand from "@/pages/studio/StudioCommand";
import StudioPillars from "@/pages/studio/StudioPillars";
import StudioAnalytics from "@/pages/studio/StudioAnalytics";
import StudioAssets from "@/pages/studio/StudioAssets";
import StudioSEO from "@/pages/studio/StudioSEO";
import StudioMemory from "@/pages/studio/StudioMemory";
import StudioNotifications from "@/pages/studio/StudioNotifications";
import StudioSuperAdmin from "@/pages/studio/StudioSuperAdmin";
import { StudioLayout } from "@/pages/studio/StudioSidebar";
import Dashboard from "@/pages/Dashboard";
import AllToolsPage from "@/pages/AllToolsPage";
import SEOToolsPage from "@/pages/SEOToolsPage";
import TechnicalSEOTools from "@/pages/TechnicalSEOTools";
import ContentTools from "@/pages/ContentTools";
import YouTubeSEOTools from "@/pages/YouTubeSEOTools";
import SocialMediaTools from "@/pages/SocialMediaTools";
import GoogleAdsTools from "@/pages/GoogleAdsTools";
import FacebookAdsTools from "@/pages/FacebookAdsTools";
import DesignTools from "@/pages/DesignTools";
import PDFTools from "@/pages/PDFTools";
import SEODashboard from "@/pages/SEODashboard";
import PublicBlogPage from "@/pages/PublicBlogPage";
import BlogViewPage from "@/pages/BlogViewPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import AuthCallback from "@/pages/AuthCallback";
import AuthPage from "@/pages/AuthPage";
import VerifyOTPPage from "@/pages/VerifyOTPPage";
import SecuritySettingsPage from "@/pages/SecuritySettingsPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";
import TaskManager from "@/pages/TaskManager";
import TeamsPage from "@/pages/TeamsPage";
import ReportsPage from "@/pages/ReportsPage";
import SiteAuditPage from "@/pages/SiteAuditPage";
import AdminPanel from "@/pages/AdminPanel";
import AdvancedSEOTools from "@/pages/AdvancedSEOTools";
import AISEOTools from "@/pages/AISEOTools";
import IntegrationsSettings from "@/pages/IntegrationsSettings";
import StudioQuickStart from "@/pages/StudioQuickStart";
import StudioCommandCenter from "@/pages/studio/StudioCommandCenter";
import StudioOpsCenter from "@/pages/studio/StudioOpsCenter";
import ComparisonPage from "@/pages/ComparisonPage";
import ClientPanel from "@/pages/ClientPanel";
import FreeToolPage from "@/pages/FreeToolPage";
import FreeToolsDirectory from "@/pages/FreeToolsDirectory";
import ReferralPage from "@/pages/ReferralPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import WhatsAppToolsPage from "@/pages/WhatsAppToolsPage";
import AIBlogGenerator from "@/pages/AIBlogGenerator";
import SharedReportPage from "@/pages/SharedReportPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import AIImageGeneratorPage from "@/pages/AIImageGeneratorPage";
import BrandKitGeneratorPage from "@/pages/BrandKitGeneratorPage";
import BadgesWidgetsPage from "@/pages/BadgesWidgetsPage";
import ProgrammaticSEOPage from "@/pages/ProgrammaticSEOPage";
import SEOPageRenderer from "@/pages/SEOPageRenderer";
import UseCasesPage from "@/pages/UseCasesPage";
import IntegrationsPage from "@/pages/IntegrationsPage";

// CRM Pages
import CRMLogin from "@/pages/crm/CRMLogin";
import CRMAuthCallback from "@/pages/crm/CRMAuthCallback";
import CRMDashboard from "@/pages/crm/CRMDashboard";
import CRMClients from "@/pages/crm/CRMClients";
import CRMTasks from "@/pages/crm/CRMTasks";
import CRMWorkLogs from "@/pages/crm/CRMWorkLogs";
import CRMWorkLibrary from "@/pages/crm/CRMWorkLibrary";
import CRMClientDetail from "@/pages/crm/CRMClientDetail";
import CRMKPIDashboard from "@/pages/crm/CRMKPIDashboard";
import CRMReports from "@/pages/crm/CRMReports";
import CRMTeam from "@/pages/crm/CRMTeam";
import CRMAIInsights from "@/pages/crm/CRMAIInsights";
import CRMCalendar from "@/pages/crm/CRMCalendar";
import CRMActivityLog from "@/pages/crm/CRMActivityLog";
import CRMSettings from "@/pages/crm/CRMSettings";
import CRMLeave from "@/pages/crm/CRMLeave";
import CRMPerformance from "@/pages/crm/CRMPerformance";
import CRMRecurring from "@/pages/crm/CRMRecurring";
import CRMTimeTracking from "@/pages/crm/CRMTimeTracking";
import { CRMAuthProvider } from "@/contexts/CRMAuthContext";

// Client Portal Pages

import TrialCountdown from "@/components/TrialCountdown";
import LoginModal from "@/components/LoginModal";
import UpgradeModal from "@/components/UpgradeModal";
import NotificationBar from "@/components/widgets/NotificationBar";
import WhatsAppButton from "@/components/widgets/WhatsAppButton";
import AIChatbot from "@/components/widgets/AIChatbot";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/hooks/useLanguage";
import { ThemeProvider } from "@/hooks/useTheme";
import { UserProvider } from "@/contexts/UserContext";
import useSEO from "@/hooks/useSEO";
import useSessionTimeout from "@/hooks/useSessionTimeout";

// Build identifier for deployment verification
const BUILD_VERSION = "v2.5.0-20260513";
console.log(`MarkeeMix Build: ${BUILD_VERSION}`);

// Suppress noisy hydration warnings caused by external visual-editor
// instrumentation (data-ve-dynamic span wrappers injected into <select>/<tbody>).
// These are cosmetic — the wrappers are not part of our React tree, so React's
// invariant about valid HTML nesting is a false positive here. We filter ONLY
// the exact two patterns so genuine warnings keep surfacing.
if (typeof window !== "undefined" && typeof console !== "undefined") {
  const _origError = console.error;
  console.error = function (...args) {
    const first = typeof args[0] === "string" ? args[0] : "";
    if (
      first.includes("In HTML, <span> cannot be a child of <select>") ||
      first.includes("In HTML, <span> cannot be a child of <option>") ||
      first.includes("In HTML, <span> cannot be a child of <tbody>") ||
      first.includes("In HTML, <span> cannot be a child of <tr>") ||
      first.includes("validateDOMNesting") && first.includes("ve-dynamic")
    ) {
      return; // swallow
    }
    return _origError.apply(console, args);
  };
}

// Global error reporter - sends unhandled errors to monitoring
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    try {
      fetch(`${BACKEND_URL}/api/monitoring/errors/report`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "js_error",
          message: event.message || "Unknown error",
          stack: event.error?.stack || "",
          url: window.location.href,
          userAgent: navigator.userAgent,
        }),
      }).catch(() => {});
    } catch (e) {}
  });
  window.addEventListener("unhandledrejection", (event) => {
    try {
      fetch(`${BACKEND_URL}/api/monitoring/errors/report`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "unhandled_promise",
          message: event.reason?.message || String(event.reason) || "Unhandled promise rejection",
          stack: event.reason?.stack || "",
          url: window.location.href,
          userAgent: navigator.userAgent,
        }),
      }).catch(() => {});
    } catch (e) {}
  });
}

// SEO wrapper component
function SEOWrapper({ children }) {
  useSEO();
  return children;
}

// Session timeout wrapper - only activates for logged in users
function SessionTimeoutWrapper({ children }) {
  useSessionTimeout();
  return children;
}

function App() {
  return (
    <ThemeProvider>
    <UserProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <PageMeta />
            <SEOWrapper>
              <SessionTimeoutWrapper>
              <NotificationBar />
              <GlobalCommandPalette />
              <Routes>
              <Route path="/" element={<PremiumHomeHero />} />
              {/* Premium Apple-grade Suite routes (Phase B) */}
              <Route path="/dashboard" element={<PremiumDashboard />} />
              <Route path="/workspace" element={<PremiumWorkspace />} />
              <Route path="/ai-studio" element={<PremiumAIStudio />} />
              <Route path="/teaching" element={<PremiumTeachingSuite />} />
              <Route path="/teaching/attendance" element={<TeachingTemplate />} />
              <Route path="/teaching/certificate" element={<TeachingTemplate />} />
              <Route path="/teaching/ppt-to-quiz" element={<PPTToQuiz />} />
              <Route path="/teaching/ai-assistant" element={<TeachingAIAssistant />} />
              <Route path="/teaching/bundles" element={<BundlesList />} />
              <Route path="/teaching/bundles/:id" element={<BundleView />} />
              <Route path="/share/bundle/:share_id" element={<PublicBundleView />} />
              <Route path="/teaching/:tool" element={<TeachingTool />} />
              <Route path="/youtube-suite" element={<PremiumYouTubeSuite />} />
              <Route path="/youtube-suite/channel-assessment" element={<PremiumChannelAssessment />} />
              <Route path="/youtube-suite/competitor-analysis" element={<SuiteTool />} />
              <Route path="/youtube-suite/thumbnail-brief" element={<SuiteTool />} />
              <Route path="/youtube-suite/video-repurpose" element={<SuiteTool />} />
              <Route path="/youtube-suite/upload-planner" element={<SuiteTool />} />
              <Route path="/content-suite" element={<PremiumContentSuite />} />
              <Route path="/content-suite/press-release" element={<SuiteTool />} />
              <Route path="/content-suite/case-study" element={<SuiteTool />} />
              <Route path="/reports" element={<PremiumReports />} />
              <Route path="/old-home" element={<HomePage />} />
              <Route path="/legacy-home" element={<NewLandingPage />} />
              <Route path="/workflows" element={<WorkflowsHub />} />
              <Route path="/workflows/project/:projectId" element={<WorkflowProject />} />
              <Route path="/workflows/:trackKey" element={<WorkflowStart />} />
              <Route path="/agencies" element={<ForAgenciesPage />} />
              <Route path="/tools/ai-slides" element={<PPTGeneratorPage />} />
              <Route path="/tools/design/thumbnail-studio" element={<ThumbnailStudioPage />} />
              <Route path="/tools/sarvam-studio" element={<SarvamStudioPage />} />
              <Route path="/tools/indic-ai" element={<SarvamStudioPage />} />
              <Route path="/tools/live-captions" element={<LiveCaptionsPage />} />
              <Route path="/tools/kimi-booster" element={<KimiBoosterPage />} />
              <Route path="/tools/keyword-booster" element={<KimiBoosterPage />} />
              <Route path="/tools/regional-toolkit" element={<RegionalToolkitPage />} />
              <Route path="/tools/indic-toolkit" element={<RegionalToolkitPage />} />
              <Route path="/tools/scale-toolkit" element={<ScaleToolkitPage />} />
              <Route path="/tools/bulk-tools" element={<ScaleToolkitPage />} />
              <Route path="/creator/incentive" element={<CreatorIncentivePage />} />
              <Route path="/tools/srt-captions" element={<SRTGeneratorPage />} />
              <Route path="/tools/auto-captions" element={<AutoCaptionsPage />} />
              <Route path="/tools/auto-captions/history" element={<AutoCaptionsHistoryPage />} />
              <Route path="/tools/auto-captions/projects/:projectId" element={<AutoCaptionsPage />} />
              <Route path="/tools/auto-captions/brand-kit" element={<AutoCaptionsBrandKitPage />} />
              <Route path="/c/:slug" element={<AutoCaptionsSharePage />} />
              <Route path="/studio" element={<StudioLayout><StudioCommand /></StudioLayout>} />
              <Route path="/studio/channels-old" element={<StudioLayout><StudioHub /></StudioLayout>} />
              <Route path="/youtube-crm" element={<StudioLayout><StudioCommand /></StudioLayout>} />
              <Route path="/youtube-crm/dashboard" element={<StudioLayout><StudioCommand /></StudioLayout>} />
              <Route path="/youtube-crm/channels" element={<StudioLayout><StudioHub /></StudioLayout>} />
              <Route path="/studio/channels" element={<StudioLayout><StudioHub /></StudioLayout>} />
              <Route path="/studio/pillars" element={<StudioLayout><StudioPillars /></StudioLayout>} />
              <Route path="/studio/analytics" element={<StudioLayout><StudioAnalytics /></StudioLayout>} />
              <Route path="/studio/assets" element={<StudioLayout><StudioAssets /></StudioLayout>} />
              <Route path="/studio/seo" element={<StudioLayout><StudioSEO /></StudioLayout>} />
              <Route path="/studio/memory" element={<StudioLayout><StudioMemory /></StudioLayout>} />
              <Route path="/studio/notifications" element={<StudioLayout><StudioNotifications /></StudioLayout>} />
              <Route path="/studio/super" element={<StudioLayout><StudioSuperAdmin /></StudioLayout>} />
              <Route path="/youtube-crm/assets" element={<StudioLayout><StudioAssets /></StudioLayout>} />
              <Route path="/youtube-crm/pillars" element={<StudioLayout><StudioPillars /></StudioLayout>} />
              <Route path="/youtube-crm/analytics" element={<StudioLayout><StudioAnalytics /></StudioLayout>} />
              <Route path="/youtube-crm/tasks" element={<StudioLayout><StudioMyTasks /></StudioLayout>} />
              <Route path="/youtube-crm/settings" element={<StudioLayout><StudioSettings /></StudioLayout>} />
              <Route path="/studio/my-tasks" element={<StudioLayout><StudioMyTasks /></StudioLayout>} />
              <Route path="/studio/calendar" element={<StudioLayout><StudioCalendar /></StudioLayout>} />
              <Route path="/studio/search" element={<StudioLayout><StudioSearch /></StudioLayout>} />
              <Route path="/studio/scorecard" element={<StudioLayout><StudioScorecard /></StudioLayout>} />
              <Route path="/studio/trash" element={<StudioLayout><StudioTrash /></StudioLayout>} />
              <Route path="/studio/approvals" element={<StudioLayout><StudioApprovals /></StudioLayout>} />
              <Route path="/studio/settings" element={<StudioLayout><StudioSettings /></StudioLayout>} />
              <Route path="/studio/workload" element={<StudioLayout><StudioWorkload /></StudioLayout>} />
              <Route path="/studio/topic-suggestions" element={<StudioLayout><StudioTopicSuggestions /></StudioLayout>} />
              <Route path="/studio/reports" element={<StudioLayout><StudioReports /></StudioLayout>} />
              <Route path="/studio/role/:role" element={<StudioLayout><StudioRoleDashboard /></StudioLayout>} />
              <Route path="/studio/billing" element={<StudioLayout><StudioBilling /></StudioLayout>} />
              <Route path="/youtube-crm/billing" element={<StudioLayout><StudioBilling /></StudioLayout>} />
              <Route path="/r/:slug" element={<StudioPublicShare />} />
              <Route path="/youtube-crm/topic-suggestions" element={<StudioLayout><StudioTopicSuggestions /></StudioLayout>} />
              <Route path="/youtube-crm/reports" element={<StudioLayout><StudioReports /></StudioLayout>} />
              <Route path="/youtube-crm/role/:role" element={<StudioLayout><StudioRoleDashboard /></StudioLayout>} />
              <Route path="/studio/channels/:channelId/sponsorships" element={<StudioLayout><StudioSponsorships /></StudioLayout>} />
              <Route path="/studio/channels/:channelId" element={<StudioLayout><StudioChannel /></StudioLayout>} />
              <Route path="/tools" element={<AllToolsPage />} />
              <Route path="/tools/seo" element={<SEOToolsPage />} />
              <Route path="/tools/seo/technical" element={<TechnicalSEOTools />} />
              <Route path="/tools/content" element={<ContentTools />} />
              <Route path="/tools/youtube" element={<YouTubeSEOTools />} />
              <Route path="/tools/youtube-seo" element={<Navigate to="/tools/youtube" replace />} />
              <Route path="/tools/social-media" element={<SocialMediaTools />} />
              <Route path="/tools/google-ads" element={<GoogleAdsTools />} />
              <Route path="/tools/facebook-ads" element={<FacebookAdsTools />} />
              {/* Ads tools - redirect to Google Ads */}
              <Route path="/tools/ads" element={<Navigate to="/tools/google-ads" replace />} />
              {/* Developer tools - redirect to SEO Technical */}
              <Route path="/tools/developer" element={<Navigate to="/tools/seo/technical" replace />} />
              {/* Utilities - redirect to Design */}
              <Route path="/tools/utilities" element={<Navigate to="/tools/design" replace />} />
              <Route path="/tools/design" element={<DesignTools />} />
              <Route path="/tools/design/pdf" element={<PDFTools />} />
              {/* Website tools - redirect to SEO page */}
              <Route path="/tools/website" element={<Navigate to="/tools/seo?tool=site-audit" replace />} />
              {/* AI tools - redirect to Content page */}
              <Route path="/tools/ai" element={<Navigate to="/tools/content?tool=ai-writer" replace />} />
              <Route path="/tools/seo/dashboard" element={<SEODashboard />} />
              <Route path="/tools/seo/advanced" element={<AdvancedSEOTools />} />
              <Route path="/tools/seo/ai" element={<AISEOTools />} />
              <Route path="/settings/integrations" element={<IntegrationsSettings />} />
              <Route path="/studio/quickstart" element={<StudioQuickStart />} />
              <Route path="/studio/operations" element={<StudioLayout><StudioCommandCenter /></StudioLayout>} />
              <Route path="/studio/triage" element={<StudioLayout><StudioOpsCenter /></StudioLayout>} />
              <Route path="/tools/site-audit" element={<SiteAuditPage />} />
              {/* Blog management - now in Admin Panel /admin -> Blogs tab */}
              <Route path="/blog" element={<PublicBlogPage />} />
              <Route path="/blogs" element={<PublicBlogPage />} />
              <Route path="/blogs/:slug" element={<BlogViewPage />} />
              <Route path="/blog-manager" element={<Navigate to="/admin" replace />} />
              <Route path="/blog-editor" element={<Navigate to="/admin" replace />} />
              <Route path="/blog-editor/:blogId" element={<Navigate to="/admin" replace />} />
              <Route path="/ai-blog" element={<AIBlogGenerator />} />
              <Route path="/report/:shareId" element={<SharedReportPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
              <Route path="/ai-image" element={<AIImageGeneratorPage />} />
              <Route path="/brand-kit" element={<BrandKitGeneratorPage />} />
              <Route path="/badges" element={<BadgesWidgetsPage />} />
              {/* Blog routes moved to bottom - uses Portfolio Blog from Admin Panel */}
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/dashboard-legacy" element={<Dashboard />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/login" element={<AuthPage />} />
              <Route path="/register" element={<AuthPage />} />
              <Route path="/signup" element={<AuthPage />} />
              <Route path="/verify-otp" element={<VerifyOTPPage />} />
              <Route path="/security" element={<SecuritySettingsPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
              <Route path="/task-manager" element={<TaskManager />} />
              <Route path="/teams" element={<TeamsPage />} />
              <Route path="/clients" element={<ClientPanel />} />
              <Route path="/reports-legacy" element={<ReportsPage />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/admin/seo" element={<ProgrammaticSEOPage />} />
              
              {/* Programmatic SEO Dynamic Routes */}
              {/* Comparison Pages - must be before SEOPageRenderer catch */}
              <Route path="/compare" element={<ComparisonPage />} />
              <Route path="/compare/:competitor" element={<ComparisonPage />} />
              
              {/* Programmatic SEO Routes */}
              <Route path="/tools/:slug" element={<SEOPageRenderer prefix="tools" />} />
              <Route path="/seo/:slug" element={<SEOPageRenderer prefix="seo" />} />
              <Route path="/best/:slug" element={<SEOPageRenderer prefix="best" />} />
              <Route path="/industry/:slug" element={<SEOPageRenderer prefix="industry" />} />
              <Route path="/location/:slug" element={<SEOPageRenderer prefix="location" />} />
              <Route path="/glossary/:slug" element={<SEOPageRenderer prefix="glossary" />} />
              <Route path="/solutions/:slug" element={<SEOPageRenderer prefix="solutions" />} />
              {/* Free Tools Landing Pages - SEO Optimized */}
              <Route path="/free" element={<FreeToolsDirectory />} />
              <Route path="/free/hashtag-generator" element={<FreeToolPage toolId="hashtag-generator" />} />
              <Route path="/free/seo-audit" element={<FreeToolPage toolId="seo-audit" />} />
              <Route path="/free/youtube-title-generator" element={<FreeToolPage toolId="youtube-title-generator" />} />
              <Route path="/free/meta-description-generator" element={<FreeToolPage toolId="meta-description-generator" />} />
              <Route path="/free/video-downloader" element={<FreeToolPage toolId="video-downloader" />} />
              <Route path="/free/instagram-image-downloader" element={<FreeToolPage toolId="instagram-image-downloader" />} />
              <Route path="/free/word-counter" element={<FreeToolPage toolId="word-counter" />} />
              <Route path="/free/keyword-research" element={<FreeToolPage toolId="keyword-research" />} />
              <Route path="/free/backlink-checker" element={<FreeToolPage toolId="backlink-checker" />} />
              <Route path="/free/title-generator" element={<FreeToolPage toolId="title-generator" />} />
              <Route path="/free/plagiarism-checker" element={<FreeToolPage toolId="plagiarism-checker" />} />
              <Route path="/free/domain-authority-checker" element={<FreeToolPage toolId="domain-authority-checker" />} />
              <Route path="/free/serp-checker" element={<FreeToolPage toolId="serp-checker" />} />
              <Route path="/free/readability-checker" element={<FreeToolPage toolId="readability-checker" />} />
              <Route path="/referral" element={<ReferralPage />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/whatsapp" element={<WhatsAppToolsPage />} />
              {/* Use Cases / Goal-based browsing */}
              <Route path="/use-cases" element={<UseCasesPage />} />
              <Route path="/use-cases/:useCaseId" element={<UseCasesPage />} />
              {/* Integrations */}
              <Route path="/integrations" element={<IntegrationsPage />} />
              
              {/* Client Portal Routes */}
              <Route path="/portal/login" element={<Navigate to="/" replace />} />
              <Route path="/portal" element={<Navigate to="/" replace />} />
              
              {/* CRM Routes - Single Provider wrapping all routes */}
              <Route path="/crm/*" element={
                <CRMAuthProvider>
                  <Routes>
                    <Route path="/login" element={<CRMLogin />} />
                    <Route path="/auth/callback" element={<CRMAuthCallback />} />
                    <Route path="/dashboard" element={<CRMDashboard />} />
                    <Route path="/clients" element={<CRMClients />} />
                    <Route path="/clients/:clientId" element={<CRMClientDetail />} />
                    <Route path="/tasks" element={<CRMTasks />} />
                    <Route path="/work-logs" element={<CRMWorkLogs />} />
                    <Route path="/work-library" element={<CRMWorkLibrary />} />
                    <Route path="/kpi" element={<CRMKPIDashboard />} />
                    <Route path="/reports" element={<CRMReports />} />
                    <Route path="/team" element={<CRMTeam />} />
                    <Route path="/ai-insights" element={<CRMAIInsights />} />
                    <Route path="/calendar" element={<CRMCalendar />} />
                    <Route path="/activity" element={<CRMActivityLog />} />
                    <Route path="/settings" element={<CRMSettings />} />
                    <Route path="/leave" element={<CRMLeave />} />
                    <Route path="/performance/:userId" element={<CRMPerformance />} />
                    <Route path="/recurring" element={<CRMRecurring />} />
                    <Route path="/time" element={<CRMTimeTracking />} />
                    <Route path="*" element={<CRMDashboard />} />
                  </Routes>
                </CRMAuthProvider>
              } />
              
              {/* Redirect old digital-marketing route to tools */}
              <Route path="/tools/digital-marketing" element={<Navigate to="/tools" replace />} />
              
              {/* Redirect removed sections to home */}
              <Route path="/blogs/*" element={<Navigate to="/blogs" replace />} />
              <Route path="/podcast_editing" element={<Navigate to="/" replace />} />
              <Route path="/portfolio/*" element={<Navigate to="/" replace />} />
              
              {/* Catch all - redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <TrialCountdown />
            <LoginModal />
            <UpgradeModal />
            <WhatsAppButton />
            <AIChatbot />
            </SessionTimeoutWrapper>
          </SEOWrapper>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </LanguageProvider>
    </UserProvider>
    </ThemeProvider>
  );
}

export default App;